import React from 'react';
import {connect} from 'react-redux';
import SettingsForm from './forms/SettingsForm';
import WizardButtons from './WizardButtons';
import {submit} from 'redux-form'
import {gettext} from '../../../../translations';
import ContactInfo from'./ContactInfo';

class WizardStepFour extends React.Component {

    render() {
        const {required, step, totalSteps, submit, onNext, onPrev, registration} = this.props;

        return (
            <div className="g-pa-0 g-ma-0 g-mb-20">
                <div className="row g-bg-white  g-pa-0 g-ma-0 g-pt-20 g-pb-0">

                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 g-hidden-lg-up g-pb-10 g-pa-0 g-ma-0 g-pl-5 gpl-10--sm g-pb-10">
                        <h5 className="g-color-primary g-mb-0 g-pb-0">{step}/{totalSteps} {gettext('Preferences')}</h5>
                        <h6 className="g-pt-2">{gettext('How do you want to receive price requests?')}</h6>
                        <p className="g-pt-8-5">{gettext('Choose the options that you find most convenient and do not miss out on any price request.')}</p>

                        <ContactInfo />
                    </div>

                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-4 col-xl-4 g-hidden-md-down">
                        <h5 className="g-color-primary">{gettext('How do you want to receive price requests?')}</h5>
                        <p className="g-pt-10 g-pb-10">{gettext('Choose the options that you find most convenient and do not miss out on any price request.')}</p>

                        <ContactInfo />
                    </div>



                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-8 col-xl-8 g-ma-0">
                        <SettingsForm initialValues={registration}
                                      required={required}
                                      onSubmit={(values) => onNext(values)}
                        />

                    </div>
                </div>

                <div className="row g-pa-0 g-ma-0 g-bg-white">
                    <div className="col-12 g-pa-0 g-ma-0">
                        <WizardButtons currentStep={step}
                                       onNext={() => submit('Registration-Settings')}
                                       onPrevious={() => onPrev()}
                        />
                    </div>
                </div>
            </div>
        )
    }
}



export default connect(null, {submit})(WizardStepFour);

